"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionHelper = void 0;
const moment_1 = __importDefault(require("moment"));
const enums_1 = require("./enums");
const productHelper_1 = require("./productHelper");
const Constants_1 = require("../Constants");
const motorCoverTiers_1 = require("../motorCoverTiers");
class InteractionHelper {
    static getQuoteType(product) {
        product = productHelper_1.productHelper.decodeShortenedProduct(product) || "";
        switch (product) {
            case enums_1.ProductsEnum.MOTOR:
                return "car";
            case enums_1.ProductsEnum.RENTERS:
                return "renters";
            default:
                throw new Error(`Uknown product - ${product}`);
        }
    }
    static getAllDrivers(interaction) {
        const drivers = [];
        if (interaction) {
            if (interaction.policyHolder) {
                drivers.push(interaction.policyHolder);
            }
            if (interaction.additionalDrivers) {
                drivers.push(...interaction.additionalDrivers);
            }
        }
        return drivers;
    }
    static getDrivingLicenceNumber(driver) {
        var _a;
        const dln = (_a = driver === null || driver === void 0 ? void 0 : driver.licence) === null || _a === void 0 ? void 0 : _a.number;
        return dln && dln.replace(/\s+/g, '').toUpperCase();
    }
    /**
     * Determines whether 2 drivers are the same person.
     *
     * Note: If at least one of the drivers doesn't have a DLN,
     * then both drivers' DLNs are considered equal,
     * regardless whether or not the other driver has a DLN.
     * Source: FAL-18277 (https://lv-digital.atlassian.net/browse/FAL-18277)
     *
     * @param driver1 - driver to compare
     * @param driver2 - driver to compare
     * @returns true if drivers are equal; false otherwise
     */
    static driversEqual(driver1, driver2) {
        var _a, _b;
        if (!driver1 || !driver2) {
            throw new Error(`Cannot compare drivers: ${!driver1 ? "driver1" : "driver2"} is undefined`);
        }
        const dln1 = (_a = this.getDrivingLicenceNumber(driver1)) === null || _a === void 0 ? void 0 : _a.slice(0, 16);
        const dln2 = (_b = this.getDrivingLicenceNumber(driver2)) === null || _b === void 0 ? void 0 : _b.slice(0, 16);
        let dlnsEqual;
        if (!dln1 || !dln2) {
            dlnsEqual = true;
        }
        else {
            dlnsEqual = dln1 === dln2;
        }
        return (dlnsEqual &&
            driver1.firstName.toLowerCase() === driver2.firstName.toLowerCase() &&
            driver1.lastName.toLowerCase() === driver2.lastName.toLowerCase() &&
            moment_1.default.utc(driver1.dateOfBirth).startOf("day").isSame(moment_1.default.utc(driver2.dateOfBirth).startOf("day")));
    }
    static isMonthlyQuoteAllowed(interaction) {
        var _a, _b;
        return productHelper_1.productHelper.isMQSQuote(interaction) ? ((_a = interaction.mqsPolicyData) === null || _a === void 0 ? void 0 : _a.instalmentAllowedStatus) === "A" : ((_b = interaction.polarisPolicyData) === null || _b === void 0 ? void 0 : _b.instalmentAllowedStatus) === "A";
    }
    static isPolicyQuotedBeforeFamilyCoverRemoval(interaction) {
        var _a, _b, _c;
        // For renewals use renewalQuoteDate instead of originalQuoteDate (NB quote date)
        const quoteDate = (_b = (_a = interaction === null || interaction === void 0 ? void 0 : interaction.factors) === null || _a === void 0 ? void 0 : _a.renewalQuoteDate) !== null && _b !== void 0 ? _b : (_c = interaction === null || interaction === void 0 ? void 0 : interaction.factors) === null || _c === void 0 ? void 0 : _c.originalQuoteDate;
        const coverRemovalDate = (0, moment_1.default)(process.env.REACT_APP_FAMILY_COVERAGE_REMOVAL_DATE);
        // Quote date might be null during NB journey before Polaris Call, in this case need to use current day to determine
        return quoteDate ? (0, moment_1.default)(quoteDate).isBefore(coverRemovalDate) : (0, moment_1.default)().isBefore(coverRemovalDate);
    }
    static getMotorTierRanking(product) {
        var _a;
        const ranking = {
            [motorCoverTiers_1.MOTOR_COVER_TIERS.MOTOR_TIER_3]: 3,
            [motorCoverTiers_1.MOTOR_COVER_TIERS.MOTOR_TIER_2]: 2,
            [motorCoverTiers_1.MOTOR_COVER_TIERS.MOTOR_TIER_1]: 1
        };
        return (_a = ranking[product]) !== null && _a !== void 0 ? _a : 0;
    }
    static isAbleToChangeRegistrationNumber(interaction) {
        const registrationNumberChangeCount = (interaction.factors.registrationNumberChangeCount) ? interaction.factors.registrationNumberChangeCount : 0;
        return registrationNumberChangeCount < Constants_1.ANNUAL_MOTOR_VRN_CHANGE_LIMIT;
    }
    /*
     * Policy-related documents (like the IPID document) have several versions. We retrieve the relevant version based on date.
     * This method is used to calculate this date according to which document versions should be retrieved.
     * The method returns a date that is relevant to the current policy year, whether this is a first year or renewal year.
     */
    static getPolicyDateForDocumentsFromPolicy(policy) {
        var _a, _b, _c, _d;
        const policyStartDate = (_d = (_c = (_b = (_a = policy === null || policy === void 0 ? void 0 : policy.interaction) === null || _a === void 0 ? void 0 : _a.renewalDetails) === null || _b === void 0 ? void 0 : _b.periodStartDate) !== null && _c !== void 0 ? _c : policy === null || policy === void 0 ? void 0 : policy.startDate) !== null && _d !== void 0 ? _d : new Date();
        return moment_1.default.utc(policyStartDate, moment_1.default.ISO_8601).toDate();
    }
    static getPolicyDateForDocumentsFromInteraction(interaction) {
        var _a, _b;
        const originalQuoteDateRaw = (_b = (_a = interaction.renewalDetails) === null || _a === void 0 ? void 0 : _a.periodStartDate) !== null && _b !== void 0 ? _b : interaction.factors.originalQuoteDate;
        return moment_1.default.utc(originalQuoteDateRaw, moment_1.default.ISO_8601).toDate();
    }
}
exports.InteractionHelper = InteractionHelper;
//# sourceMappingURL=InteractionHelper.js.map